import React, { FC } from 'react';

const PaginationElipsisCell: FC = () => (
  <div className="pagination-elipsis-cell">
    <span className="elipsis">...</span>
  </div>
);

export default PaginationElipsisCell;
